import { Splide, SplideSlide } from "@splidejs/react-splide";

import { stylesConfig } from "../helpers/stylesConfig";
import useDeviceType from "../hook/useDeviceType";
import { useTranslation } from "react-i18next";
import LazyImage from "./Loading/lazyImage";
import List from "../pages/Promotion/components/LIST";
import { Link } from "react-router-dom";

const carouselList = stylesConfig.carouselImages;

const Carousel = () => {
  const { i18n } = useTranslation();

  const isMobile = useDeviceType() === "Mobile";

  const promotionList = List();
  return (
    <section className="">
      <Splide
        className="h-full w-full"
        options={{
          type: isMobile ? "fade" : "loop",
          rewind: true,
          perPage: 2,
          gap: 30,
          autoplay: true,
          arrows: false,
          breakpoints: {
            640: {
              perPage: 1,
            },
            768: {
              perPage: 2,
            },
            1024: {
              perPage: 2,
            },
          },
        }}
      >
        {promotionList?.map((list, index) => {
          return (
            <SplideSlide key={index}>
              <Link
                to={
                  list.type === "recommend"
                    ? "/terms/friend-recommend"
                    : `/promotion/detail/${index}`
                }
              >
                <LazyImage
                  src={list.image_mobile}
                  closeInverted
                  fetchPriority="high"
                  alt={list.title}
                  className={`sm:h-[280px] h-[200px] !w-full rounded-[8px] object-cover `}
                />
              </Link>
            </SplideSlide>
          );
        })}
      </Splide>
    </section>
  );
};

export default Carousel;
